import {
    defineBlock,
    smartProps,
    ChildrenBlock,
    useInspectorControl,
    useSmartProp,
    useEditor,
} from '@smartfire/js-block-engine';
import MinimalWrapper from '../minimal-wrapper/block';
import { m } from 'framer-motion';
import { varFade } from '../components/animate';
import { PanelBody, PanelRow, SelectControl } from '@wordpress/components';

function Inspector() {
    const [variant, setVariant] = useSmartProp('variant');

    return (
        <>
            <PanelBody title="Animation" initialOpen={true}>
                <PanelRow>
                    <SelectControl
                        label="Animation Type"
                        value={variant}
                        onChange={(value) => {
                            setVariant(value);
                        }}
                        options={[
                            { value: 'in', label: 'in' },
                            { value: 'inRight', label: 'inRight' },
                            { value: 'inLeft', label: 'inLeft' },
                            { value: 'inUp', label: 'inUp' },
                            { value: 'inDown', label: 'inDown' },
                            { value: 'out', label: 'out' },
                            { value: 'outRight', label: 'outRight' },
                            { value: 'outLeft', label: 'outLeft' },
                            { value: 'outUp', label: 'outUp' },
                            { value: 'outDown', label: 'outDown' },
                        ]}
                    />
                </PanelRow>
            </PanelBody>
        </>
    );
}

function Block({ variant, ...props }) {
    useInspectorControl(Inspector);
    const { isEditing } = useEditor();
    return (
        <MinimalWrapper>
            <m.div
                variants={!isEditing ? varFade()[variant] : null}
                style={isEditing ? { marginTop: 10, marginBottom: 10 } : null}
            >
                <ChildrenBlock
                    childrenProps={props}
                    gutenbergEditorConfig={{
                        orientation: 'vertical',
                        allowedBlocks: [
                            'core/paragraph',
                            'core/heading',
                            'core/list',
                            'smartfire/animated',
                            'smartfire/text-animated',
                            'smartfire/button',
                            'core/image',
                            'smartfire/text-disabled',
                            'smartfire/grid',
                            'smartfire/card',
                            'smartfire/box',
                            'core/spacer',
                            'smartfire/spacer',
                            'smartfire/simulator',
                        ],
                    }}
                />
            </m.div>
        </MinimalWrapper>
    );
}

export default defineBlock({
    Block,
    smartProps: {
        variant: smartProps.string.withDefault('inRight'),
    },
    setup: {},
});
